import React from 'react';
import { Chip } from 'primereact/chip';

function group_color(group) {
    let color = "grey"
    switch (group) {
        case "Admin":
            color = "#FF9280"
            break;
        case "User":
            color = "#00C0C0"
            break;
        case "Analytics":
            color = "#FFDA9D"
            break;
        case "ECS":
            color = "#8AE28A"
            break;
        case "Monitoring":
            color = "#D397F8"
            break;
        default:
            break;
    }
    return color
}

function status_color(status) {
    let color = "grey"
    switch (status) {
        case "CONFIRMED":
            color = "#077186"
            break;
        case "UNCONFIRMED":
            color = "#00C0C0"
            break;
        case "ARCHIVED":
            color = "#FFDA9D"
            break;
        case "FORCE_CHANGE_PASSWORD":
            color = "orange"
            break;
        case "Monitoring":
            color = "#D397F8"
            break;
        default:
            break;
    }
    return color
}


export const USER_COLUMNS = [
    {
        header: 'Enabled',
        field: 'enabled',
        sortable:true,
        body: (rowdata) => {
            if (rowdata.enabled){
               return  <i className="pi pi-check-circle" style={{ color: '#13866f', fontSize:'1.25rem'}}></i>
            }else{
                return <i className="pi pi-times-circle" style={{ color: '#d64545', fontSize:'1.25rem'}}></i>
            }
        },
        align:'center',
        style:{width:'5%'}
    },
    
    {
        header: 'Originator',
        field: 'platform',
        sortable: true,
        // Display-only - the raw custom:Platform Cognito attribute isn't
        // always cased consistently (e.g. internal accounts stored as
        // "exaloan"), and this table shouldn't force-lowercase the rest of
        // real platform names (e.g. "ITFGroup") to fix just the first letter.
        body: (rowdata) => {
            const platform = rowdata.platform || '';
            return platform.charAt(0).toUpperCase() + platform.slice(1);
        }
    },
    {
        header: 'Email',
        field: 'email',
        sortable: true
    },
    {
        header: 'Groups',
        field: 'groups',
        body: (rowdata) => {
            return rowdata.groups.map((col, i) => {
                return <Chip key={i} id='group' label={col} style={{ background: group_color(col), color: 'black', marginRight: '5px', borderRadius: '100px' }} />
            });
        }
    },
    
    {
        header: 'Status',
        field: 'status',
        sortable:true,
        body: (rowdata) => {
            return <Chip  id='status' label={rowdata.status} style={{ background: status_color(rowdata.status), color: 'white', marginRight: '5px', borderRadius: '100px' }} />
        }
    }
]

